import { SerializeQueryArgs, defaultSerializeQueryArgs } from "@reduxjs/toolkit/query";
import { axiosNewPrivate } from "../util/axios";

/**
 * Cache-key serializer that scopes an RTK Query entry to the tenant the request
 * is actually sent for — the end-user app's counterpart of admin-ui's
 * `api/tenantCacheKey.ts` (same name, same contract; see
 * `docs/architecture/tenant-scoped-caching.md`).
 *
 * RTK Query keys an entry by `endpointName(serializedArg)`; the tenant travels
 * in the `X-Tenant` header, so without this two tenants share one entry. The
 * tenant is read from the header the new-backend axios instance stamps on every
 * request, so key and header cannot disagree.
 *
 * First adopted by the room week slice (#3036). The older end-user slices
 * predate it; adopting it there is a separate change.
 */
export const serializeQueryArgsWithTenant: SerializeQueryArgs<unknown> = (params) => {
  const tenant = String(axiosNewPrivate.defaults.headers?.["X-Tenant"] ?? "");
  return `${tenant}|${defaultSerializeQueryArgs(params)}`;
};

export default serializeQueryArgsWithTenant;
